var brandStyles = {
  home: {
    background: "backgroundLight",
    backgroundDark: "backgroundBlack",
    cartButtonCounterBackground: "primary",
    navigationListMarkerColor: "primary",
    navigationBackLinkCustomColor: "primary"
  },
  homecloud: {
    background: "backgroundLight",
    backgroundDark: "backgroundBlack",
    cartButtonCounterBackground: "primary",
    navigationListMarkerColor: "primary",
    navigationBackLinkCustomColor: "primary"
  },
  ionos: {
    background: "backgroundDarker",
    backgroundDark: "backgroundBlack",
    cartButtonCounterBackground: "primaryLight",
    navigationListMarkerColor: "primaryLight"
  },
  strefa: {
    background: "backgroundDark",
    backgroundDark: "backgroundBlack",
    cartButtonCounterBackground: "primaryLight",
    navigationListMarkerColor: "primaryLight"
  }
};
export default brandStyles;